function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import { get } from "lodash";
import { isSet } from "./isSet";
import { getFullScope } from "./getFullScope";
import { inferType } from "./inferType";
export function lookup(i18n, scope) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  options = Object.assign({}, options);
  var locale = "locale" in options ? options.locale : i18n.locale;
  var localeType = inferType(locale);
  var locales = i18n.locales.get(localeType === "string" ? locale : _typeof(locale)).slice();
  scope = getFullScope(i18n, scope, options).split(i18n.defaultSeparator).map(function (component) {
    return i18n.transformKey(component);
  }).join(".");
  var entries = locales.map(function (locale) {
    return get(i18n.translations, [locale, scope].join("."));
  });
  entries.push(options.defaultValue);
  return entries.find(function (entry) {
    return isSet(entry);
  });
}